__turbopack_context__.v({
  "Caption": "hG1qAq_Caption",
  "Img": "hG1qAq_Img",
  "Root": "hG1qAq_Root",
  "Root--Contain": "hG1qAq_Root--Contain",
  "Root--Cover": "hG1qAq_Root--Cover",
  "skeleton-loading": "hG1qAq_skeleton-loading",
});
